module.exports = __webpack_public_path__ + "static/media/gigapotti-red.6c608cd1.svg";